module.exports = __webpack_public_path__ + "static/media/galerija_2014 (9).b556bdba.jpg";